import React from 'react';

export const notificationsConfigs = [
  {
    permittedRole:'agence',
    path: '/historique/notifications',
    component: React.lazy(() => import('./notificationList/index')),
  },
];
